import pageStore from '@/bps/stores/page/PageStore';
import httpRequest from '@/bps/utilities/js/httpRequest/httpRequest';
import jsGlobalConfig from '@/bps/globals/jsGlobalConfig';
import pigeon from '@/bps/utilities/js/pigeon/pigeon';

class PageService {
  constructor() {
    pigeon.subscribe('page:setVoucher', (data: string) => {
      pageStore.activeVoucherCode = data;
    });
  }

  async redeemVoucherCode(voucherCode: string) {
    return httpRequest.post(
      `/addVoucher/?voucherCode=${voucherCode}`,
      null,
      {
        headers: jsGlobalConfig().getCsrfTokenHeader(),
      }
    ).then((response) => {
      if (response.data.voucherValidationResult.successful || response.data.voucherValidationResult.attainable) {
        pageStore.activeVoucherCode = response.data.voucherValidationResult.voucherCode;
      }

      pigeon.publish('basket:reload');
      return response.data;
    });
  }
}

const pageService = new PageService();
export default pageService;
export {PageService};
